function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import angular from 'angular';
import { AccesoDatos } from 'src/_candidato/comun/services/acceso-datos';
var CONFIG_NO_GESTION_ERROR = {
  _cfg: {
    nogestionaerror: true
  }
};
export var CurriculumService = /*#__PURE__*/function () {
  CurriculumService.$inject = ["$log", "AccesoDatos"];
  function CurriculumService($log, AccesoDatos) {
    _classCallCheck(this, CurriculumService);
    this.$log = $log;
    this.AccesoDatos = AccesoDatos;
    this.CLIENT = this.AccesoDatos.Curr_CLIENT;
  }
  return _createClass(CurriculumService, [{
    key: "sendCv",
    value: function sendCv(req) {
      var accesoPublico = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      if (accesoPublico) {
        return this.CLIENT.nuevoCV(req, CONFIG_NO_GESTION_ERROR);
      } else {
        return this.sendCvPriv(req);
      }
    }
  }, {
    key: "sendCvPriv",
    value: function sendCvPriv(req) {
      return this.CLIENT.nuevoCV_Secured(req, CONFIG_NO_GESTION_ERROR);
    }
  }]);
}();
angular.module('candidato').service('CurriculumService', CurriculumService);